<template>
  <main class="user">
    <dashboard v-show="path=='dashboard'"/>
    <participants v-show="path=='participants'"/>
    <accommodation v-show="path=='accommodation'"/>
    <teams v-show="path=='teams'"/>
    <larp_teams v-show="path=='larp_teams'"/>
    <boardgames v-show="path=='boardgames'"/>
    <more v-show="path=='more'"/>
    <activities v-show="path=='activities'"/>
    <finance v-show="path=='finance'"/>
    <outpost v-show="path=='outpost'"/>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import dashboard from "../pages/dashboard.vue";
import participants from "../pages/participants.vue";
import accommodation from "../pages/accommodation.vue";
import teams from "../pages/teams";
import larp_teams from '../pages/larp_teams.vue';
import boardgames from '../pages/boardgames.vue';
import more from "../pages/more.vue";
import activities from "../pages/activities.vue";
import finance from "../pages/finance.vue";
import outpost from "../pages/outpost.vue";

export default {
  name: "user",
  components: {
    dashboard,
    participants,
    accommodation,
    teams,
    larp_teams,
    boardgames,
    more,
    activities,
    finance,
    outpost,
  },
  computed: {
    ...mapState(["path"])
  }
};
</script>